<template>
  <div class="task_pop_bg">
    <!-- 标题 -->
    <div class="topSpot"></div>
    <div class="bottomSpot"></div>
    <div class="topBorder"></div>
    <div class="titleLine">
      <div class="info_title">
        <div class="titleLine_name">
          <span class="leftLine"></span
          ><span style="color: #2ac1ff">任务详情</span>
        </div>
        <div class="closeBtn" @click="closeTaskDetail"></div>
      </div>
    </div>
    <div class="middleOutLine">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
      >
        <!-- <div class="notisfy">关联消息：{{resultData.level|getlevelName}}</div> -->
        <el-form-item label="任务标题">
          <el-input v-model="ruleForm.title" disabled></el-input>
        </el-form-item>
        <el-form-item label="任务内容" prop="taskContent">
          <el-input
            type="textarea"
            v-model="ruleForm.taskContent"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-input v-model="ruleForm.statusTranslated" disabled></el-input>
        </el-form-item>
        <el-form-item label="责任人">
          <el-input v-model="ruleForm.receiveUser" disabled></el-input>
        </el-form-item>
        <el-form-item label="任务地址">
          <el-input v-model="ruleForm.address" disabled></el-input>
        </el-form-item>
        <el-form-item label="任务坐标">
          <el-input v-model="ruleForm.zuobiao" disabled></el-input>
        </el-form-item>
        <div class="mapBox">
          <div class="map" id="allmap" style="width: 100%; height: 100%"></div>
          <!-- <div class="coverbg"></div> -->
        </div>
        <el-form-item label="截止时间">
          <el-input v-model="ruleForm.endTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="完成时间" v-if="ruleForm.status == '1'">
          <el-input v-model="ruleForm.finishTime" disabled></el-input>
        </el-form-item>
        <el-form-item
          label="完成说明"
          prop="finishIntro"
          v-if="ruleForm.status == '1'"
        >
          <el-input
            type="textarea"
            v-model="ruleForm.finishIntro"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="图片" v-if="FeedAttachImgList.length > 0">
          <el-image
            v-for="(ele, index) in FeedAttachImgList"
            :key="index"
            v-bind:src="ele.FileUrl"
            style="width: 100px; height: 130px; padding-right: 10px"
            :preview-src-list="getPreviewImgList(index)"
          />
        </el-form-item>
        <el-form-item
          label="视频"
          v-if="FeedAttachVideoList.length > 0"
          style="text-align: left"
        >
          <video
            v-for="(ele, index) in FeedAttachVideoList"
            :key="index"
            controls
            style="width: 300px; height: 150px; margin-bottom: 10px"
          >
            <source v-bind:src="ele.FileUrl" type="video/mp4" />
            <source v-bind:src="ele.FileUrl" type="video/ogg" />
            Your browser does not support the video tag.
          </video>
        </el-form-item>
        <el-form-item label="关闭时间" v-if="ruleForm.status == '3'">
          <el-input v-model="ruleForm.closeTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="关闭人" v-if="ruleForm.status == '3'">
          <el-input v-model="ruleForm.closeUser" disabled></el-input>
        </el-form-item>
        <el-form-item label="关闭原因" v-if="show || ruleForm.status == '3'">
          <el-input v-model="ruleForm.closeReson"></el-input>
        </el-form-item>
        <el-form-item
          style="margin-top: 10px; display: flex; justify-content: flex-end"
          v-if="!show && ruleForm.status != '3'"
        >
          <el-button @click="showClosebtn()">关闭任务</el-button>
        </el-form-item>
        <el-form-item
          style="margin-top: 10px; display: flex; justify-content: flex-end"
          v-if="show"
        >
          <el-button @click="closeTask()">确认关闭</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="bottomBorder"></div>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
import Constant from "../config/constant";

import {
  getIntegratedTaskById,
  updateIntegratedTask,
} from "@/api/src/integratedTask";

export default {
  data() {
    return {
      ruleForm: {
        receiveUser: null,

        title: null,
        taskContent: null,

        messageId: null,
        status: null,

        address: null,
        longitude: 0,
        latitude: 0,
        endTime: null,
        zuobiao: null,
      },
      rules: {
        closeReson: [
          { required: true, message: "请输入内容", trigger: "blur" },
        ],
      },
      IsEdit: false,
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      imgList: [],
      fileList: [],
      delFileList: [],
      currentValue: "",
      preValue: "",
      resultData: {},
      handleStatus: false, //false为待处理，true为已处理
      detailData: {},
      show: false,
      center: [],
      center2: [],
      isHavePosition: false,
      FeedAttachImgList: [],
      FeedAttachVideoList: [],
    };
  },
  filters: {
    getlevelName(val) {
      if (val == "warning_level_1") {
        return "一级";
      } else if (val == "warning_level_2") {
        return "二级";
      } else if (val == "warning_level_3") {
        return "三级";
      }
    },
  },
  props: {
    TaskId: {
      type: String,
      default: "",
    },
    isLookDetails: {
      type: Boolean,
      default: false,
    },
  },
  created: function () {
    if (this.isLookDetails) {
      this.getTaskDetails();
    }
  },
  mounted: function () {},
  methods: {
    showClosebtn() {
      this.show = true;
    },
    getTaskDetails() {
      let that = this;

      getIntegratedTaskById(this.TaskId).then((response) => {
        const data = response.data;
        that.ruleForm = response.data;
        that.ruleForm.zuobiao = data.longitude + "," + data.longitude;
        if (data.longitude & data.latitude) {
          that.isHavePosition = true;
          that.center.push(data.longitude);
          that.center.push(data.latitude);
        }
        if (response.data.uploadResource) {
          const files = response.data.uploadResource.split(",");
          that.FeedAttachImgList = [];
          that.FeedAttachVideoList = [];
          files.forEach((item) => {
            const spliceLength = item.lastIndexOf(".");
            let FileType = item.slice(spliceLength + 1);

            if (that.isImage(FileType)) {
              let imgobj = {};
              imgobj.FileUrl = item;
              imgobj.src = item;

              that.FeedAttachImgList.push(imgobj);
            }
            if (that.isVideo(FileType)) {
              let videoobj = {};
              videoobj.FileUrl = item;
              videoobj.src = item;
              that.FeedAttachVideoList.push(videoobj);
            }
          });
        }

        that.onDrawMap();
      });
    },
    closeTaskDetail() {
      this.$emit("closeTaskDetail", false);
    },
    closeTask() {
      let that = this;
      this.ruleForm.status = Constant.TaskStatus.Closed.code;
      this.ruleForm.closeUser = ZJApp.ZJUser.current.UserName;
      this.ruleForm.closeTime = new Date().format("yyyy-MM-dd hh:mm:ss");
      updateIntegratedTask(this.ruleForm).then((response) => {
        if (response.code === 200) {
          that.$message({
            type: "success",
            message: "任务关闭成功",
          });
          that.$emit("closeTaskDetail", false);
        }
        that.$emit("newtaskcreated");
      });
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    goCenter: function () {
      let that = this;
      // eslint-disable-next-line no-undef
      console.log("this.center");
      console.log(this.center);
      // if(this.center.length>0){
      // eslint-disable-next-line no-undef
      console.log("this.center");
      console.log(this.center);
      this.mapInstance.panTo(new BMap.Point(this.center[0], this.center[1]));
      that.addDom();
      // setTimeout(() => {
      //   if(that.isHavePosition){
      //     that.addDom();
      //   }else{
      //     that.addMarker(that.mapInstance,that.center)
      //   }

      // }, 1000);
      // }else{
      //   this.getMapCenter();
      //   setTimeout(() => {
      //     // eslint-disable-next-line no-undef
      //     this.mapInstance.panTo(new BMap.Point(this.center2[0], this.center2[1]));
      //     if(that.isHavePosition){
      //       that.addDom();
      //     }else{
      //       that.addMarker(that.mapInstance,that.center2)
      //     }
      //   }, 2000);
      // }
    },
    onDrawMap: function () {
      let center = this.center;
      var map = new BMap.Map("allmap");
      var point = new BMap.Point(center[0], center[1]);
      map.centerAndZoom(point, 15);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
    },
    addMarker: function (map, point) {
      if (!map) return null;
      this.marker = map.createOverlay(
        point,
        {
          url: "/lib/zjmap/Content/images/noposition.png",
          width: 100,
          height: 75,
          offsetX: 24,
          offsetY: 48,
        },
        null,
        {
          enableClicking: false,
        }
      );
      map.addOverlay(this.marker);
      return this.marker;
    },
    addDom: function () {
      if (!this.mapInstance) return;
      // var layer = this.mapInstance.getLayerByName("DOM");
      this.ComplexCustomOverlay.prototype = new BMap.Overlay();
      this.ComplexCustomOverlay.prototype.initialize = function (map) {
        // var layer = this.mapInstance.addOverlay;
        // console.log('layer')
        // console.log(layer)
        // if (layer && layer.addDom)
        this._map = map;
        // eslint-disable-next-line no-undef
        var $div = $("<div></div>");
        $div.append(this.getSvgContent());
        $div.css({
          width: "30rem",
          height: "30rem",
          "margin-left": "-15rem",
          "margin-top": "-15rem",
          position: "absolute",
        });
        this.mapInstance.getPanes().labelPane.appendChild($div);

        return $div;
      };
      let center = this.center;
      var myCompOverlay = new this.ComplexCustomOverlay(
        new BMap.Point(center[0], center[1])
      );

      this.mapInstance.addOverlay(myCompOverlay);
      // var label = new BMap.Label($div,{offset:new BMap.Size(20,-10)});
      //   marker.setLabel(label);
      //   layer.addDom(this.center[0], this.center[1], $div[0]);
      // }
    },
    // 复杂的自定义覆盖物
    ComplexCustomOverlay(point, text, mouseoverText) {
      this._point = point;
      this._text = text;
      this._overText = mouseoverText;
    },
    getSvgContent: function () {
      var html =
        "" +
        '<div class="svg_container">' +
        '  <div class="svg-box">' +
        '     <svg version="1.1"  x="0px" y="0px" viewBox="0 0 100 100"' +
        '         enable-background="new 0 0 100 100" xml:space="preserve">' +
        '       <circle fill="rgba(244,16,11,5)" cx="50" cy="50" r="5" />' +
        '       <circle fill="rgba(244,16,11,0.2)" cx="50" cy="50" r="20" />' +
        '       <circle fill="rgba(244,16,11,0.1)" cx="50" cy="50" r="35" />' +
        "     </svg>" +
        "  </div>" +
        '  <div class="circle delay1"></div>' +
        '  <div class="circle delay2"></div>' +
        '  <div class="circle delay3"></div>' +
        "</div>";
      return html;
    },
    getPreviewImgList(index) {
      let arr = [];
      for (let i = 0; i < this.FeedAttachImgList.length; i++) {
        arr.push(this.FeedAttachImgList[i + index].FileUrl);
        if (i + index >= this.FeedAttachImgList.length - 1) {
          index = 0 - (i + 1);
        }
      }
      return arr;
    },
    isImage: function (filename) {
      return ZJApp.ZJUtils.isImage(filename);
    },
    isVideo: function (filename) {
      return ZJApp.ZJUtils.isVideo(filename);
    },
  },
};
</script>
<style scoped lang="scss">
.task_pop_bg {
  width: 36.5%;
  position: fixed;
  left: 50%;
  top: 120px;
  z-index: 9999;
  margin-left: -18.2%;
  box-sizing: border-box;
  border-bottom-left-radius: 22px;
  .topBorder {
    width: 100%;
    // height:34px;
    // padding-top:64px;
    height: 34px;
    background: url("../../../../../../assets/pop_tz.png") no-repeat;
    background-size: 100% 34px;
    position: relative;
  }
  .bottomBorder {
    width: 100%;
    height: 25px;
    background: url("../../../../../../assets/pop_bz.png") no-repeat;
    background-size: 100%;
  }
  .titleLine {
    width: 100%;
    box-sizing: border-box;
    background: rgba(15, 36, 69, 0.8);
    border-left: 1px solid #2ac1ff;
    border-right: 1px solid #2ac1ff;
    padding-bottom: 10px;
    position: relative;
    .info_title {
      width: 92%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px dashed #2ac1ff;
      padding-bottom: 10px;
    }
    .titleLine_name {
      display: flex;
      align-items: center;
      .leftLine {
        display: inline-block;
        width: 2px;
        height: 15px;
        margin-right: 10px;
        background: #2ac1ff;
      }
    }
    .closeBtn {
      width: 20px;
      height: 20px;
      background: url("../../../theme-default/src/img/close.png") no-repeat;
      background-size: 20px;
      position: absolute;
      right: 20px;
      top: 0px;
      z-index: 999999;
    }
  }
  .middleOutLine {
    height: 40.8rem;
    overflow: auto;
    width: 100%;
    padding: 0 10px;
    border-left: 0.5px solid #2ac1ff;
    border-right: 0.5px solid #2ac1ff;
    //  background:rgba(26,49,70,0.3);
    background-color: rgba(15, 36, 69, 0.8);
  }
  .notisfy {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 3%;
    font-size: 12px;
    margin-bottom: 15px;
  }
  .topSpot {
    width: 222px;
    height: 125px;
    background: url("../../../../../../assets/spot.png") no-repeat;
    position: absolute;
    right: 15px;
    top: -62px;
    z-index: 12000;
  }
  .bottomSpot {
    width: 222px;
    height: 120px;
    background: url("../../../../../../assets/spot.png") no-repeat;
    // background-size:cover;
    position: absolute;
    left: -35px;
    bottom: -45px;
    z-index: 10000;
  }
}
.mapBox {
  width: 86%;
  // width: 96%;
  height: 200px;
  padding: 0px 10px 16px 3px;
  // padding: 24px 20px 16px 26px;
  box-sizing: border-box;
  position: relative;
  // margin-left:20px;
  float: right;
}
.coverbg {
  // width: 525px;
  width: 100%;
  height: 274px;
  background: url("../../../../../../assets/mapborder.png") no-repeat;
  background-size: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
}
</style>
